const SearchIcon = ({ width }) => {
    return (
        <div className={`${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 88 88"
            >
                <path
                    fill="#414042"
                    d="M34.512 67.934C15.79 67.934.559 52.711.559 34 .559 15.288 15.789.065 34.512.065 53.234.065 68.465 15.288 68.465 34c0 18.711-15.231 33.934-33.953 33.934zm0-60.778C19.702 7.156 7.653 19.198 7.653 34c0 14.801 12.05 26.843 26.859 26.843 14.81 0 26.858-12.042 26.858-26.843 0-14.802-12.048-26.844-26.858-26.844z"
                ></path>
                <path
                    fill="#414042"
                    d="M58.625 52.874l-5.017 5.014 29.284 29.267 5.016-5.014-29.283-29.267z"
                ></path>
            </svg>
        </div>
    )
}

export default SearchIcon
